<nz-spin
  nzSimple
  nzSize="large"
  [class.black]="black()"
  [class.showEnd]="showEnd()"
></nz-spin>
